// extracted by mini-css-extract-plugin
export default {"checkbox":"StatusHeader_checkbox__iaBPN","placeHolderShimmer":"StatusHeader_placeHolderShimmer__DZb62"};